import React from "react";
import "./DashboardContent.css";

export default function DashboardContent({ children }) {
  return <div className="dashboardContent">{children}</div>;
}
